import React, { useEffect, useState } from 'react';
import NumberInputWithUnit from '../../../../../../atomic/inputs/numberInputWithUnit/NumberInputWithUnit';
import InfoIconComponent from '../../InfoIcon';
import style from './ExitTacticModules.module.css';
import PropTypes from 'prop-types';
import RatchetBracketDocs from '../../../../documentation/RatchetBracketDocs';
import { UnitIndicator } from '../../../../../../atomic/formElements/unitIndicator/UnitIndicator';
import { colors } from '../../../../../../../colorVars';

function RatchetBracketModule({ state }) {
  const [ratchetBracket, dispatchRatchetBracket, , setRatchetBracketEnabled] =
    state;
  const perBracketLabels = {
    PROFIT: 'Num. of Brackets',
    QUANTITY: 'Qty. per Bracket',
    PERCENT: '% per Bracket',
    DEFAULT: 'Qty. Basis Value',
  };

  const [targetPerBracketDisplay, setTargetPerBracketDisplay] = useState(0);
  const [stopPerBracketDisplay, setStopPerBracketDisplay] = useState(0);
  const [qtyBasisValuePerBracketDisplay, setQtyBasisValuePerBracketDisplay] =
    useState(0);
  const [trailQtyBasisValueDisplay, setTrailQtyBasisValueDisplay] = useState(0);

  useEffect(() => {
    setRatchetBracketEnabled(true);
  }, []);

  useEffect(() => {
    setTargetPerBracketDisplay(ratchetBracket.targetPerBracket ?? 0);
    setStopPerBracketDisplay(ratchetBracket.stopPerBracket ?? 0);
    setQtyBasisValuePerBracketDisplay(
      (ratchetBracket.qtyBasis === 'QUANTITY' ||
      ratchetBracket.qtyBasis === 'PROFIT'
        ? ratchetBracket.qtyBasisValuePerBracket
        : ratchetBracket.qtyBasisValuePerBracket * 100) ?? 0
    );
    setTrailQtyBasisValueDisplay(
      (ratchetBracket.qtyBasis === 'QUANTITY'
        ? ratchetBracket.trailQtyBasisValue
        : ratchetBracket.trailQtyBasisValue * 100) ?? 0
    );
  }, [state]);

  return (
    <div className={style.moduleStyle}>
      <span className={style.tacticName}>
        <InfoIconComponent docs={RatchetBracketDocs} /> Ratchet Bracket
      </span>
      <div className={style.inputs}>
        <div className={style.inputAndLabel}>
          <p className={style.labelAndIndicator}>
            {' '}
            <UnitIndicator
              margin="0 3px 0 0"
              height={12}
              width={12}
              color={
                ratchetBracket.qtyBasis === 'PROFIT'
                  ? colors.green
                  : ratchetBracket.qtyBasis === 'PERCENT'
                  ? colors.orange
                  : colors.blue
              }
            />
            Qty. Basis
          </p>
          <select
            value={ratchetBracket.qtyBasis}
            onChange={({ target }) => {
              dispatchRatchetBracket({ qtyBasis: target.value });
              dispatchRatchetBracket({ qtyBasisValuePerBracket: 0 });
              dispatchRatchetBracket({ trailQtyBasisValue: 0 });
            }}
          >
            <option value="PROFIT">Profit</option>
            <option value="QUANTITY">Quantity</option>
            <option value="PERCENT">Percentage</option>
          </select>
        </div>

        <div className={style.inputAndLabel}>
          <p>
            {ratchetBracket.qtyBasis === 'PROFIT'
              ? 'Target Profit'
              : 'Target Price'}
          </p>
          <NumberInputWithUnit
            inputWidth="5em"
            direction="left"
            type="number"
            value={targetPerBracketDisplay}
            setValue={setTargetPerBracketDisplay}
            onBlur={(value) =>
              dispatchRatchetBracket({ targetPerBracket: value })
            }
          >
            $
          </NumberInputWithUnit>
        </div>

        <div className={style.inputAndLabel}>
          <p>
            {ratchetBracket.qtyBasis === 'PROFIT' ? 'Stop Loss' : 'Stop Price'}
          </p>
          <NumberInputWithUnit
            inputWidth="5em"
            direction="left"
            type="number"
            value={stopPerBracketDisplay}
            setValue={setStopPerBracketDisplay}
            onBlur={(value) =>
              dispatchRatchetBracket({ stopPerBracket: value })
            }
          >
            $
          </NumberInputWithUnit>
        </div>

        <div className={style.inputAndLabel}>
          <p>
            {perBracketLabels[ratchetBracket.qtyBasis] ||
              perBracketLabels.DEFAULT}
          </p>
          <NumberInputWithUnit
            direction={ratchetBracket.qtyBasis === 'PERCENT' ? 'right' : 'left'}
            type="number"
            value={qtyBasisValuePerBracketDisplay}
            setValue={setQtyBasisValuePerBracketDisplay}
            onBlur={(value) =>
              dispatchRatchetBracket({
                qtyBasisValuePerBracket:
                  ratchetBracket.qtyBasis === 'PERCENT'
                    ? Number(value) / 100
                    : value,
              })
            }
          >
            {ratchetBracket.qtyBasis === 'PERCENT' ? '%' : '#'}
          </NumberInputWithUnit>
        </div>

        <div className={style.inputAndLabel}>
          <p>
            {ratchetBracket.qtyBasis === 'QUANTITY' ? 'Trail Qty.' : 'Trail %'}
          </p>
          <NumberInputWithUnit
            direction={
              ratchetBracket.qtyBasis === 'QUANTITY' ? 'left' : 'right'
            }
            type="number"
            value={trailQtyBasisValueDisplay}
            setValue={setTrailQtyBasisValueDisplay}
            onBlur={(value) => {
              dispatchRatchetBracket({
                trailQtyBasisValue:
                  ratchetBracket.qtyBasis === 'QUANTITY'
                    ? value
                    : Number(value) / 100,
              });
            }}
          >
            {ratchetBracket.qtyBasis === 'QUANTITY' ? '#' : '%'}
          </NumberInputWithUnit>
        </div>
      </div>
    </div>
  );
}
RatchetBracketModule.propTypes = {
  state: PropTypes.array.isRequired,
};
export default RatchetBracketModule;
